'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import Image from "next/image";


const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Programs', href: '/programs' },
  { label: 'Activity', href: '/activities' },
  { label: 'Contact', href: '/contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <>
      <header data-component-id="src/components/Header.tsx:44:6" data-component-path="src/components/Header.tsx" data-component-line="44" data-component-end-line="123" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? 'glass-nav py-3 shadow-float' : 'bg-transparent py-5 '
        }`}
      >
        <div data-component-id="src/components/Header.tsx:49:8" data-component-path="src/components/Header.tsx" data-component-line="49" data-component-end-line="122" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%20flex%20items-center%20justify-between%22%7D" className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <Link data-component-id="src/components/Header.tsx:50:10" data-component-path="src/components/Header.tsx" data-component-line="50" data-component-end-line="68" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%2C%22className%22%3A%22flex%20items-center%20group%22%7D" href="/" className="flex items-center group">
  <Image data-component-id="src/components/Header.tsx:51:2" data-component-path="src/components/Header.tsx" data-component-line="51" data-component-end-line="60" data-component-file="Header.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fassets%2Fimages%2FRP-college-favicon.png%22%2C%22alt%22%3A%22Shri%20R.%20P.%20College%20of%20Pharmacy%22%7D"
  src="/assets/images/RP-college-favicon.png"
  alt="Shri R. P. College of Pharmacy"
  width={280}
  height={90}
  priority
  className={`w-auto transition-all duration-500 group-hover:scale-105 ${
    scrolled ? 'h-16' : 'h-40'
  }`}
/>
  {/* <span
    className={`font-serif text-lg font-normal tracking-tight transition-colors duration-300 ${
      scrolled ? 'text-foreground' : 'text-white'
    }`}
  >
    Shri R. P. College of Pharmacy
  </span> */}
</Link>

          {/* Desktop Nav */}
          <nav data-component-id="src/components/Header.tsx:71:10" data-component-path="src/components/Header.tsx" data-component-line="71" data-component-end-line="87" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22hidden%20md%3Aflex%20items-center%20gap-8%22%7D" className="hidden md:flex items-center gap-8">
            {navLinks?.map((link) => (
              <Link data-component-id="src/components/Header.tsx:73:14" data-component-path="src/components/Header.tsx" data-component-line="73" data-component-end-line="85" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                key={link?.href}
                href={link?.href}
                className={`nav-link-hover transition-colors duration-300 ${
                  scrolled ? '' : 'text-white/80 hover:!text-white'
                } ${
                  pathname === link?.href ||
                  (link?.href !== '/' && pathname?.startsWith(link?.href))
                    ? 'nav-link-active' :''
                }`}
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          <div data-component-id="src/components/Header.tsx:89:10" data-component-path="src/components/Header.tsx" data-component-line="89" data-component-end-line="96" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20md%3Aflex%20items-center%20gap-4%22%7D" className="hidden md:flex items-center gap-4">
            <Link data-component-id="src/components/Header.tsx:90:12" data-component-path="src/components/Header.tsx" data-component-line="90" data-component-end-line="95" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fadmissions%22%2C%22className%22%3A%22btn-primary%20text-sm%20py-2.5%20px-5%22%2C%22textContent%22%3A%22Admission%22%7D"
              href="/admissions"
              className="btn-primary text-sm py-2.5 px-5"
            >
              Admission
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button data-component-id="src/components/Header.tsx:99:10" data-component-path="src/components/Header.tsx" data-component-line="99" data-component-end-line="121" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            className={`md:hidden flex flex-col gap-1.5 p-2 rounded-lg transition-colors ${
              scrolled ? 'text-foreground' : 'text-white'
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          >
            <span data-component-id="src/components/Header.tsx:106:12" data-component-path="src/components/Header.tsx" data-component-line="106" data-component-end-line="110" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`block w-6 h-0.5 bg-current transition-all duration-300 ${
                menuOpen ? 'rotate-45 translate-y-2' : ''
              }`}
            />
            <span data-component-id="src/components/Header.tsx:111:12" data-component-path="src/components/Header.tsx" data-component-line="111" data-component-end-line="115" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`block w-6 h-0.5 bg-current transition-all duration-300 ${
                menuOpen ? 'opacity-0' : ''
              }`}
            />
            <span data-component-id="src/components/Header.tsx:116:12" data-component-path="src/components/Header.tsx" data-component-line="116" data-component-end-line="120" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`block w-6 h-0.5 bg-current transition-all duration-300 ${
                menuOpen ? '-rotate-45 -translate-y-2' : ''
              }`}
            />
          </button>
        </div>
      </header>
      {/* Mobile Menu */}
      {menuOpen && (
        <div data-component-id="src/components/Header.tsx:126:8" data-component-path="src/components/Header.tsx" data-component-line="126" data-component-end-line="143" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20z-40%20glass-nav%20flex%20flex-col%20pt-24%20pb-10%20px-6%22%7D" className="fixed inset-0 z-40 glass-nav flex flex-col pt-24 pb-10 px-6">
          <nav data-component-id="src/components/Header.tsx:127:10" data-component-path="src/components/Header.tsx" data-component-line="127" data-component-end-line="139" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22flex%20flex-col%20gap-6%20flex-1%22%7D" className="flex flex-col gap-6 flex-1">
            {navLinks?.map((link) => (
              <Link data-component-id="src/components/Header.tsx:129:14" data-component-path="src/components/Header.tsx" data-component-line="129" data-component-end-line="137" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                key={link?.href}
                href={link?.href}
                className={`text-2xl font-serif transition-colors duration-300 ${
                  pathname === link?.href ? 'text-primary' : 'text-foreground'
                }`}
              >
                {link?.label}
              </Link>
            ))}
          </nav>
          <Link data-component-id="src/components/Header.tsx:140:10" data-component-path="src/components/Header.tsx" data-component-line="140" data-component-end-line="142" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fadmissions%22%2C%22className%22%3A%22btn-primary%20justify-center%20w-full%22%2C%22textContent%22%3A%22Admission%22%7D" href="/admissions" className="btn-primary justify-center w-full">
            Admission
          </Link>
        </div>
      )}
    </>
  );
}